// Helper function to format integer strings with commas
export const formatIntegerWithCommas = (numStr: string): string => {
  if (!numStr || numStr === "-" || !/^-?\d+$/.test(numStr)) {
    return numStr;
  }
  const isNegative = numStr.startsWith("-");
  const absNumStr = isNegative ? numStr.substring(1) : numStr;

  if (absNumStr === "") return numStr; // Should already be caught by !/^-?\d+$/ if numStr was only "-"

  const formattedAbs = absNumStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return isNegative ? `-${formattedAbs}` : formattedAbs;
};

export const formatPriceForScreen = (
  e: any,
  priceUpdateType: "price" | "stopPrice",
  priceType: string,
  setpriceValue: any,
  setStopPrice: any,
) => {
  const currentValue = e.target.value?.toString();

  if (currentValue === null || currentValue.trim() === "") {
    return;
  }

  const valueWithoutCommas = currentValue.replaceAll(",", "");
  let finalDisplayValue = "";

  if (priceType === "NotFractional") {
    const parts = valueWithoutCommas.split(".");
    const integerPart = parts[0];
    const decimalPart = parts.length > 1 ? "." + parts.slice(1).join(".") : "";
    finalDisplayValue = formatIntegerWithCommas(integerPart) + decimalPart;
  } else {
    // Fractional priceType
    const separator = "'"; // Assuming ' is the primary fractional separator
    const parts = valueWithoutCommas.split(separator);
    const basePart = parts[0];
    const fractionalRemainder =
      parts.length > 1 ? separator + parts.slice(1).join(separator) : "";
    finalDisplayValue = formatIntegerWithCommas(basePart) + fractionalRemainder;
  }
  priceUpdateType === "price"
    ? setpriceValue(finalDisplayValue)
    : setStopPrice(finalDisplayValue);
};

export const removeCommasOnFocus = (
  e: any,
  priceUpdateType: "price" | "stopPrice",
  setpriceValue: any,
  setStopPrice: any,
  priceType: string,
) => {
  const currentValue = e.target.value?.toString();
  if (!currentValue) return;

  let processedValue = currentValue.replaceAll(",", "");

  if (priceType === "NotFractional" && processedValue.includes(".")) {
    const num = parseFloat(processedValue);
    if (!isNaN(num)) {
      let str = num.toString();
      if (str.includes("e-")) {
        // It's in scientific notation with a negative exponent.
        const exponent = parseInt(str.split("e-")[1], 10);
        if (!isNaN(exponent)) {
          // Use toFixed to expand scientific notation to a full decimal string.
          processedValue = num.toFixed(exponent);
        }
      } else {
        processedValue = str;
      }
    }
  }
  if (processedValue !== currentValue) {
    priceUpdateType === "price"
      ? setpriceValue(processedValue)
      : setStopPrice(processedValue);
  }
};
